import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';

interface ResponsiveDiagramProps {
  imageName: string;
  alt: string;
}

const ResponsiveDiagram: React.FC<ResponsiveDiagramProps> = ({ imageName, alt }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  
  // Determine which image size to use based on screen size
  const getImageSrc = () => {
    if (isMobile) {
      return `/images/${imageName}-mobile.png`;
    } else if (isTablet) {
      return `/images/${imageName}-tablet.png`;
    } else {
      return `/images/${imageName}-desktop.png`;
    }
  };
  
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center',
      alignItems: 'center',
      p: { xs: 1, sm: 2, md: 3 },
      bgcolor: '#f8f9fa',
      borderRadius: 2,
      border: '1px solid #e0e0e0',
    }}>
      <img 
        src={getImageSrc()}
        alt={alt}
        style={{ 
          width: '100%',
          height: 'auto',
          maxWidth: '100%',
          borderRadius: 8,
          boxShadow: '0 6px 20px rgba(25, 118, 210, 0.12)',
          backgroundColor: 'white',
          display: 'block'
        }}
        loading="lazy"
      />
    </Box>
  );
};

export default ResponsiveDiagram;